import { Helmet } from "react-helmet-async";

type HeadProps = {
	children: string | JSX.Element;
};

export const Head = (props: HeadProps) => {
	const { children } = props;

	return (
		<Helmet>
			<title>{children}</title>
		</Helmet>
	);
};
